import { render } from "./batchSendGsKk.vue?vue&type=template&id=f2fed274&scoped=true"
import script from "./batchSendGsKk.vue?vue&type=script&lang=js"
export * from "./batchSendGsKk.vue?vue&type=script&lang=js"

import "./batchSendGsKk.vue?vue&type=style&index=0&id=f2fed274&lang=less&scoped=true"
import "./batchSendGsKk.vue?vue&type=style&index=1&id=f2fed274&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fed274"]])

export default __exports__